const NOTION_URL_PATTERN =
  /^https:\/\/(?:(?:www\.)?notion\.(?:so|com)|[\w-]+\.notion\.(?:site|com)|app\.notion\.com)\//i;

const NOTION_PAGE_ID_PATTERN =
  /[-/]([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[a-f0-9]{32})\/?(?:[?#].*)?$/i;

export const isNotionUrl = (uri: string): boolean =>
  NOTION_URL_PATTERN.test(uri);

export const extractNotionPageId = (uri: string): string | undefined => {
  const match = uri.match(NOTION_PAGE_ID_PATTERN);
  if (!match) return undefined;
  return match[1].replaceAll('-', '');
};
